module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/mv-f22d85ffc07cf6de6e4189af635010ae.png";